export default __webpack_public_path__ + "static/main-48f379f618362ee9e8e0d07d98cc0557.mp4";